import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { Collection, FiltersBase } from "../../types"
import { COLLECTION_TYPES, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Collection>()

export function TableCollections({
  collections,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  collections: Collection[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!collections) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [collections, count])

  return (
    <Table
      data={collections}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(collection) => (
          <Link to={`/collections/collections/${collection.id}`}>
            <LinkMagik className="text-dark">{collection.name}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Categoria"
        name="category"
        sortable
        width="minmax(max-content, 2fr)"
        render={(collection) => COLLECTION_TYPES.find((ct) => ct.value === collection.category)?.label || collection.category}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} raccolte
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
